// src/pages/Dashboard/Admin/DetailsAdherents/components/AdherentKpiCards.jsx

import React from "react";
import {
  FaCalendarCheck,
  FaCheckCircle,
  FaClipboardCheck,
  FaEuroSign,
  FaMedal,
  FaShoppingBag,
  FaTrophy,
  FaUserCog,
  FaUsers,
} from "react-icons/fa";

import { formatCurrency } from "../utils/adherentDashboardUtils";

function KpiCard({ label, value, helper, icon, tone = "indigo", loading }) {
  const tones = {
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    rose:
      "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300",
    slate:
      "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800/70 dark:text-slate-300",
  };

  return (
    <div className={`rounded-[24px] border p-4 ${tones[tone]}`}>
      {loading ? (
        <div className="h-16 animate-pulse rounded-2xl bg-white/70 dark:bg-slate-900/50" />
      ) : (
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/80 text-lg dark:bg-slate-900/50">
            {icon}
          </div>

          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] opacity-75">
              {label}
            </p>

            <p className="mt-0.5 truncate text-xl font-semibold text-slate-950 dark:text-white">
              {value}
            </p>

            {helper ? (
              <p className="mt-0.5 truncate text-xs text-slate-600 dark:text-slate-300">
                {helper}
              </p>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

export default function AdherentKpiCards({ stats, loading }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        loading={loading}
        label="Groupes"
        value={stats.groupsCount}
        helper="Affectations actuelles"
        icon={<FaUsers />}
        tone="indigo"
      />

      <KpiCard
        loading={loading}
        label="Gestionnaires"
        value={stats.managersCount}
        helper="Comptes associés"
        icon={<FaUserCog />}
        tone="emerald"
      />

      <KpiCard
        loading={loading}
        label="Dossier"
        value={stats.dossierCompleted ? "Complet" : "À vérifier"}
        helper="CM / licence / règlement"
        icon={stats.dossierCompleted ? <FaCheckCircle /> : <FaClipboardCheck />}
        tone={stats.dossierCompleted ? "emerald" : "amber"}
      />

      <KpiCard
        loading={loading}
        label="Règlement"
        value={formatCurrency(stats.reglementTotal)}
        helper={stats.reglementStatus}
        icon={<FaEuroSign />}
        tone="emerald"
      />

      <KpiCard
        loading={loading}
        label="Ceintures"
        value={stats.beltsCount}
        helper="Passages enregistrés"
        icon={<FaMedal />}
        tone="amber"
      />

      <KpiCard
        loading={loading}
        label="Compétitions"
        value={stats.competitionsCount}
        helper="Inscriptions liées"
        icon={<FaTrophy />}
        tone="indigo"
      />

      <KpiCard
        loading={loading}
        label="Achats"
        value={formatCurrency(stats.achatsStats.total)}
        helper={`${stats.achatsStats.count} achat(s)`}
        icon={<FaShoppingBag />}
        tone="slate"
      />

      <KpiCard
        loading={loading}
        label="Présences"
        value={stats.attendanceStats.presents}
        helper={`${stats.attendanceStats.total} séance(s)`}
        icon={<FaCalendarCheck />}
        tone="emerald"
      />
    </div>
  );
}